__turbopack_context__.v({
  "attributes": "styles-module__lhEFgG__attributes",
  "modalProductList": "styles-module__lhEFgG__modalProductList",
  "modalProductListContainer": "styles-module__lhEFgG__modalProductListContainer",
  "placeholderProductList": "styles-module__lhEFgG__placeholderProductList",
  "placeholderTile": "styles-module__lhEFgG__placeholderTile",
  "seeMoreText": "styles-module__lhEFgG__seeMoreText",
});
